export default __webpack_public_path__ + "static/media/google_map_daily_status.5f5d35ea.png";